import { registerComponent } from "helpers";

registerComponent(
  "quantity-stepper",
  class QuantityStepper extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector("input");
      this.changeEvent = new Event("change", { bubbles: true });

      this.querySelectorAll("button").forEach((button) =>
        button.addEventListener("click", this.onButtonClick.bind(this)),
      );

      this.checkMinMaxValues();
    }

    onButtonClick(event) {
      const previousValue = this.input.value;

      event.preventDefault();

      if (event.currentTarget.name === "plus") {
        this.input.stepUp();
      } else {
        this.input.stepDown();
      }

      if (previousValue !== this.input.value) {
        this.input.dispatchEvent(this.changeEvent);
      }

      this.checkMinMaxValues();
    }

    checkMinMaxValues() {
      const inputValue = parseInt(this.input.value, 10);
      const minValue = parseInt(this.input.min, 10);
      const maxValue = parseInt(this.input.max, 10);
      const minusButton = this.querySelector("button[name=minus]");
      const plusButton = this.querySelector("button[name=plus]");

      if (minValue >= inputValue) {
        minusButton.setAttribute("disabled", "");
      } else {
        minusButton.removeAttribute("disabled");
      }

      if (inputValue >= maxValue) {
        plusButton.setAttribute("disabled", "");
      } else {
        plusButton.removeAttribute("disabled");
      }
    }
  },
);
